import React from "react";
import NavBar from "../../nav/nav-bar";
import Header from "../../header/header";
import ReportNav from "../report-nav";
import Footer from "../../footer/footer";
import { useState } from "react";
import { useEffect } from "react";
import Service from "../../webservice/http";
import { debounce } from "lodash";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";
import config from "../../config";
import Pagination from "../../components/pagination";
import { storage } from "../../utils/storage";
import ReportFilter from "../report-filter";
import { FaFilter } from "react-icons/fa";
import ReportFilterBanner from "../report-filter-banner";

function Latedue() {
  const tableHeadingArray = [
    " Call Date ",
    "Audit Date",
    "Customer Name",
    "Product",
    "Agent",
    "Call Language",
    "Manager",
    "Reviewer",
    "Action",
  ];

  const services = new Service();
  const history = useHistory();
  const role = storage.getItem("role");
  const isAgentRole =
    role === "Agent" ||
    role === "Agenth" ||
    role === "Agent Collections" ||
    role.includes("Agent");

  const [tabledata, setTabledata] = useState([]);
  const [search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);
  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [maxpage, settMaxpage] = useState("");

  // Global report filter state
  const [reportFilterWidth, setReportFilterWidth] = useState(0);
  const [isReportFilterOpen, setIsReportFilterOpen] = useState(false);
  const [reportFilters, setReportFilters] = useState({});

  const changeReportFilterWidth = () => {
    if (reportFilterWidth === 550) {
      setReportFilterWidth(0);
      setIsReportFilterOpen(false);
    } else {
      setReportFilterWidth(550);
      setIsReportFilterOpen(true);
    }
  };

  const handleReportFilterApply = (appliedFilters) => {
    setReportFilters(appliedFilters);
  };

  const handleReportFilterReset = () => {
    setReportFilters({});
  };

  const buildQueryParams = (filters) => {
    const params = new URLSearchParams();
    const mapping = {
      lob: "lob_name",
      manager: "manager_name",
      team_lead: "team_lead_name",
      agent: "agent_name",
      dca_organization: "dca_organization_name",
      dca_manager: "dca_manager_name",
      dca_team: "dca_team_lead_name",
      dca_agent: "dca_agent_name",
      collection_strategy: "collection_strategy",
      product_type: "product_name",
      time_period: "period",
      from_date: "from_date",
      to_date: "to_date",
      bucket_type: "bucket_type",
    };
    for (const [key, value] of Object.entries(filters)) {
      if (mapping[key] && value) params.append(mapping[key], value);
      else if (value && !mapping[key]) params.append(key, value);
    }
    return params.toString().replace(/\+/g, "%20");
  };

  async function Dashbaorddata(filters = {}) {
    setLoading(true);

    const params = new URLSearchParams();
    if (search) params.append("search", search);
    const filterQs = buildQueryParams(filters);
    if (filterQs) {
      filterQs.split("&").forEach((pair) => {
        const [k, v] = pair.split("=");
        if (k && v) params.append(decodeURIComponent(k), decodeURIComponent(v));
      });
    }
    const qs = params.toString().replace(/\+/g, "%20");
    const url = `api/call_verification/post-due-greater-than-60-days/${
      qs ? `?${qs}` : ""
    }`;

    const res = await services.get(url).then((res) => {
      setTabledata(res?.data);
      setTotalpage(res?.pagination?.page_numbers);
      setTotalresult(res?.pagination?.total_results);
      settMaxpage(res?.pagination?.total_pages);
      setLoading(false);
    });
  }

  const debouncedSearch = debounce((value) => {
    setSearch(value.toLowerCase());
  }, 500);

  // console.log(localStorage.getItem("access_token"));

  const downloadReport = async function () {
    let downloadUrl = `${config.API_BASE_URL}/api/call_verification/post-due-greater-than-60-days-download/`;

    if (search) {
      downloadUrl = downloadUrl + `?search=${search}`;
    }

    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${storage.getItem("access_token")}`,
        },
      });
      // console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // console.log(url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "dashboard_data.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    Dashbaorddata(reportFilters);
  }, [search, reportFilters]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    history.push(`/reports/latedue/?page=${pageNumber}`);
  };

  return (
    <div>
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid" style={{ background: "#EEF2F5" }}>
          <div className="my-call">
            <div
              className="side-panel-with-table clearfix flex"
              style={{ display: "flex" }}
            >
              <ReportNav />
              <div
                className="call-table bg-white"
                style={{ marginBottom: "80px" }}
              >
                {/* Active filter banner — non-agent roles */}
                {!isAgentRole && (
                  <ReportFilterBanner
                    filters={reportFilters}
                    onClear={handleReportFilterReset}
                  />
                )}
                <div
                  className="my-calls-column"
                  style={{ padding: "15px 0px 0px 15px" }}
                >
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i
                              className="fa fa-snowflake-o"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="pannel-heading-info">
                            <h3>Late Collection &gt; 90 days</h3>
                            <p> Details</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" flex justify-end  my-10 items-center gap-4">
                  <input
                    onChange={(event) => debouncedSearch(event.target.value)}
                    type="text"
                    placeholder="Search by customer name"
                    className="search-tag"
                    style={{
                      // border: "1px solid transparent",
                      border: "none",
                      background: "#eef2f5",
                      borderRadius: "10px",
                      width: "250px",
                      outline: "none",
                      paddingLeft: "8px",
                      height: "35px",
                    }}
                  />

                  <button
                    className={` text-white px-8 py-3 rounded-xl export-btn tracking-wide ${
                      !tabledata?.length ? " opacity-60" : ""
                    }`}
                    disabled={!tabledata?.length}
                    onClick={downloadReport}
                  >
                    Export
                  </button>
                </div>

                <div className=" overflow-x-scroll">
                  <table className="ss" style={{ border: "1px solid grey" }}>
                    <tr id="black-line">
                      {tableHeadingArray.map((item, indx) => (
                        <th
                          key={item}
                          className={`
                               left-0 bg-white  border-b-2 border-gray-200 px-5 py-4 text-left  text-xl font-semibold  tracking-wider text-black  
                                
                               }  `}
                        >
                          {item}
                        </th>
                      ))}
                    </tr>

                    <tbody>
                      {Loading && (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </td>
                        </tr>
                      )}

                      {tabledata.length ? (
                        tabledata.map((e, i) => {
                          return (
                            <tr
                              key={i}
                              // className={`${
                              //   e["Call Status"] === "Fatal"
                              //     ? " bg-red-500"
                              //     : " bg-green-500"
                              // }`}
                              className=" cursor-pointer"
                              // style={{ background: "red" }}
                              onClick={() =>
                                history.push(`/detailed-reports/${e.id}`)
                              }
                            >
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs first-letter `}
                              >
                                <div>
                                  <p className="whitespace-no-wrap cursor-pointer text-center text-sky-700">
                                    {e.call_date}
                                  </p>
                                </div>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2  text-xs`}
                                id="date"
                              >
                                <p className="whitespace-nowrap text-left text-gray-900 ">
                                  {e.audit_date}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2    text-xs`}
                                id="date"
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.customer_name}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs`}
                              >
                                <p className="whitespace-no-wrap text-left text-gray-900">
                                  {e?.product}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.agent}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.language}
                                </p>
                              </td>

                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs whitespace-nowrap`}
                              >
                                <p className="  text-left text-gray-900">
                                  {e?.team_lead}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs whitespace-nowrap`}
                              >
                                <p className="  text-left text-gray-900">
                                  {e?.qa_lead}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2  w-40 text-xs cursor-pointer`}
                              >
                                <a className="text-left text-gray-900 whitespace-nowrap">
                                  View More
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : Loading ? (
                        ""
                      ) : (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalpage?.length}
                    onPageChange={handlePageClick}
                    totalresult={totalresult}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Global Report Filter — non-agent roles only */}
      {!isAgentRole && (
        <>
          <button
            onClick={changeReportFilterWidth}
            title="Global Filters"
            style={{
              position: "fixed",
              transition: "0.5s",
              top: "30%",
              right: reportFilterWidth > 0 ? reportFilterWidth + 8 : 25,
              backgroundColor:
                Object.keys(reportFilters).length > 0 ? "#271078" : "#F99E52",
              color: "white",
              padding: "10px",
              height: "40px",
              width: "40px",
              zIndex: 2001,
              borderRadius: "10%",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FaFilter size={18} />
            {Object.keys(reportFilters).length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "-4px",
                  backgroundColor: "#F99E52",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  fontSize: "10px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {Object.keys(reportFilters).length}
              </span>
            )}
          </button>

          <ReportFilter
            width={reportFilterWidth}
            changeSideBarWidth={changeReportFilterWidth}
            onApplyFilter={handleReportFilterApply}
            onResetFilter={handleReportFilterReset}
            userRole={role}
          />

          {isReportFilterOpen && (
            <div
              className="backdrop"
              onClick={changeReportFilterWidth}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.35)",
                zIndex: 1999,
              }}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Latedue;
